import React from 'react';
import PropTypes from 'prop-types';

const InLineError = props => {
        return (
            <div className="inlineError">
                {props.message}
            </div>
        );
};

InLineError.propTypes ={
    message: PropTypes.string.isRequired
};

export default InLineError;
